// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2V_HJ","col":"styles_col__28ErB"};